const RESULTS_FRAME = "events_results"

export const BOUND_KEYS = ["n", "s", "e", "w"]

// Turbo updates history asynchronously, so the frame's own src is the reliable
// source of the filters that produced the results currently on screen.
export function filterSource() {
  const frame = document.getElementById(RESULTS_FRAME)
  const src = frame && frame.getAttribute("src")
  return new URL(src || window.location.href, window.location.href)
}

export { RESULTS_FRAME }
